import { useEffect, useState, useRef } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useDebouncedValue<T = any>(value: T, wait: number) {
  const [_value, setValue] = useState(value)
  const mountedRef = useRef(false)
  const timeoutRef = useRef<number | undefined>(undefined)
  const cooldownRef = useRef(false)

  const cancel = () => window.clearTimeout(timeoutRef.current)

  useEffect(() => {
    if (mountedRef.current) {
      if (!cooldownRef.current) {
        cooldownRef.current = true
        setValue(value)
      } else {
        cancel()
        timeoutRef.current = window.setTimeout(() => {
          cooldownRef.current = false
          setValue(value)
        }, wait)
      }
    }
  }, [value, wait])

  useEffect(() => {
    mountedRef.current = true
    return cancel
  }, [])

  return [_value] as const
}
